module.exports = __webpack_public_path__ + "icons/original/large/large-c4.83eef6ef77656276b988cffc6dd1b2dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-c4.png
// module id = mGEC
// module chunks = app